import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from '../pages/Login';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthorized } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        正在加载...
      </div>
    );
  }

  if (!user || !isAuthorized) {
    return <Login />;
  }

  return children;
};

export default ProtectedRoute;
